module.exports = __webpack_public_path__ + "img/img18.cbec04b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img18.jpg
// module id = 314
// module chunks = 0